<template>
  <form-wrapper :validator="$v.predlzenie">
    <b-row>
      <h4 style="margin-bottom: 20px; padding-left: 15px">
        {{ $t('message.oznamenie.header') }}
      </h4>

      <b-col cols="8">
        <b-form-group
          v-for="i in checkboxes"
          :key="i+'c'"
          :name="i"
          input-cols="12"
          label=""
        >
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              v-model="$v.predlzenie[i].$model"
              v-bind="attrs"
              v-on="listeners"
              value="1"
              unchecked-value="0"
              plain
              style="align-items: baseline;"
            >
              {{ $t('message.oznamenie.'+ i) }}
            </b-form-checkbox>
          </template>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group
          :input-cols="8"
          :label="$t('message.oznamenie.dtpLehota')"
          name="dtpLehota"
        >
          <template slot-scope="{ attrs, listeners }">
            <date-picker
              v-model="$v.predlzenie.dtpLehota.$model"
              v-bind="attrs"
              :language="sk"
              v-on="listeners"
              class="dpicker"
              monday-first
              bootstrap-styling
              calendar-class="vdp-cal"
              format="dd.MM.yyyy"
              input-class="dp"
              placeholder="?? created_date ??"
            />
          </template>
        </b-form-group>
      </b-col>
    </b-row>

    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>
  </form-wrapper>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { sk } from 'vuejs-datepicker/dist/locale'
import bFormGroup from '@/components/form-group-col6'
import datePicker from 'vuejs-datepicker';
import restEditor from '@/mixins/restEditor';

export default {
  components: {
    bFormGroup,
    datePicker
  },

  mixins: [restEditor],

  data () {
    return {
      sk,
      checkboxes: ['cbPismA', 'cbPismB'],
      predlzenie: {
        cbPismA: null,
        cbPismB: null,
        dtpLehota: null
      },
      saved: false
    }
  },

  validations: {
    predlzenie: {
      cbPismA: {},
      cbPismB: {},
      dtpLehota: { required }
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.$route.params.oznamenie = false
    })
  },

  methods: {
    processGet() {
      // this.predlzenie = await this.restDataSource.getData(this.$route.params.userId, 'predlzenie');
    },
    processSave () {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        // await this.$axios.put(`dppo/oznamenie/${this.$route.params.poid}`, this.oznamenie).catch(() => {})
        this.$v.$reset()
        this.saved = true
        setTimeout(() => {
          this.saved = false
        }, 3000)
      }
    }
  }
}
</script>
